import ProductService from '@/api/ProductService'
import LocalStorage from 'store'
import { uuid } from 'vue-uuid'
import _ from 'lodash'
import FirebaseService from '@/api/FirebaseService'

// initial state
const state = {
  pos: {
    // page section
    // 'choose-product', 'choose-ataddPosNextQueuetribut', 'custom-price', 'queues', 'tables', 'customers', 'dining , 'payment', 'payment-complate'
    // 'mobile-prepayment', 'mobile-category', 'mobile-discount', 'mobile-notification'
    section: 'choose-product',
    // before section
    prevSection: null,
    // data from api
    products: [],
    // display
    display: {
      type: 'grid', // 'grid', 'list'
      use_calculator: false,
      search: false,
    },
    // selected data
    selected: {
      // use for ChooseProduct Page
      category_id: undefined,
      // use for ChooseAttribute Page, selected product
      product: null,
      // use for CustomPrice Page, custom price
      sku_id: null,
      // current select queue
      queue_number: null,
      // current showing table
      table_number: null,
      // use for select dining option
      dining_name: null,
      // use for add customer to the order
      customer_id: null,
      // is new customer
      customer_new: false,
      // keep lots temporary
      lots: [],
      // keep serials temporary
      serials: [],
      // temp any things, any data type
    },
    edit: {
      order: null, // order data edit
    },
    // next queue number
    latestQueueNumber: null,
    // used queue numbers
    usedQueueNumbers: [],
    // queues
    queues: [],
    // orders detail
    orders: [],
    // tables details
    tables: [],
    // trick calculate total price
    trickCalculateTotalPrice: 0,
    // data bills
    stockBills: [],
    // receipt info
    receiptInfo: {
      paid: 0, // paid money number
      change: 0, // change money number
      bi_code: null,
      paymentMethod: null,
    },
    // temp
    lastSecIsBarcode: false,
    addedItemCount: 0,
    removedItemCount: 0,
    isShowingConfirmClearPosOrdersModal: false,
    // notify from firebase
    notifications: [],
  },
}

function getTotal (orders, mixin) {
  const result = mixin.getTotal(orders)
  return {
    sub: result.sub,
    discount: result.discount,
    tax: result.taxes.all,
    total: result.payment,
  }
}

// compare new order with old one
function getOrderWithCompare (newOrder, oldOrders) {
  return oldOrders.find(oldOrder => {
    // check table_number and sku_id
    if (newOrder.queue_number == oldOrder.queue_number && newOrder.table_number == oldOrder.table_number && newOrder.sku_id == oldOrder.sku_id) {
      if (
        comparePrice(newOrder, oldOrder) &&
          compareModifiers(newOrder, oldOrder) &&
          compareDiscounts(newOrder, oldOrder) &&
          compareTaxes(newOrder, oldOrder) &&
          compareLots(newOrder, oldOrder) &&
          compareSerials(newOrder, oldOrder) &&
          compareNote(newOrder, oldOrder) &&
          compareRefkey(newOrder, oldOrder)
      ) {
        return oldOrder
      }
    }
  })
}

// compare attributes

function comparePrice (x, y) {
  if (x.price !== y.price) {
    return false
  }
  return true
}

function compareModifiers (x, y) {
  if (x.modifiers.length !== y.modifiers.length) {
    return false
  }

  var xModiIds = []
  var yModiIds = []

  x.modifiers.map(obj => {
    xModiIds.push(obj.modifier_id)
  })

  y.modifiers.map(obj => {
    yModiIds.push(obj.modifier_id)
  })

  if (!_.isEqual(xModiIds.sort(), yModiIds.sort())) {
    return false
  }

  for (let i in x.modifiers) {
    var xOptions = []

    x.modifiers[i].options.map(obj => {
      xOptions.push(obj.modifieroption_id)
    })

    for (let j in y.modifiers) {
      if (y.modifiers[j].modifier_id == x.modifiers[i].modifier_id) {
        var yOptions = []

        y.modifiers[j].options.map(obj => {
          yOptions.push(obj.modifieroption_id)
        })

        if (!_.isEqual(xOptions.sort(), yOptions.sort())) {
          return false
        }
      }
    }
  }

  return true
}

function compareDiscounts (x, y) {
  if (x.discounts.length !== y.discounts.length) {
    return false
  }

  var xDisIds = []
  var yDisIds = []

  x.discounts.map(obj => {
    xDisIds.push(obj.discount_id)
  })

  y.discounts.map(obj => {
    yDisIds.push(obj.discount_id)
  })

  if (!_.isEqual(xDisIds.sort(), yDisIds.sort())) {
    return false
  }

  return true
}

function compareTaxes (x, y) {
  if (x.taxes.length !== y.taxes.length) {
    return false
  }

  var xTaxIds = []
  var yTaxIds = []

  x.taxes.map(obj => {
    xTaxIds.push(obj.tax_id)
  })

  y.taxes.map(obj => {
    yTaxIds.push(obj.tax_id)
  })

  if (!_.isEqual(xTaxIds.sort(), yTaxIds.sort())) {
    return false
  }

  return true
}

function compareLots (x, y) {
  if (x.lots || y.lots) {
    return false
  }
  return true
}

function compareSerials (x, y) {
  if (x.serials || y.serials) {
    return false
  }
  return true
}

function compareNote (x, y) {
  if (x.note !== y.note) {
    return false
  }
  return true
}

function compareRefkey (x, y) {
  if (x.order_id !== y.order_id) {
    return false
  }
  return true
}

// getters
const getters = {
  getPosSection: state => {
    return {
      'current': state.pos.section,
      'prev': state.pos.prevSection,
    }
  },
  getPos: state => state.pos,
  getPosDisplay: state => state.pos.display,
  getPosProducts: state => state.pos.products,
  getPosOrders: state => state.pos.orders,
  getPosOrdersById: (state) => ({ queue_number, table_number }) => {
    return state.pos.orders.filter(order =>
      order.queue_number == queue_number &&
      order.table_number == table_number
    )
  },
  getPosTotalPriceById: (state) => ({ queue_number, table_number }, mixin) => {
    let orders = state.pos.orders.filter(order =>
      order.queue_number == queue_number &&
      order.table_number == table_number
    )
    return getTotal(orders, mixin)
  },
  getBillTotalPrice: (state) => (orders, mixin) => {
    return getTotal(orders, mixin)
  },
  getPosSelectedCategoryId: state => state.pos.selected.category_id,
  getPosSelectedProduct: state => state.pos.selected.product,
  getPosSelectedSkuId: state => state.pos.selected.sku_id,
  getPosSelectedQueueNumber: state => state.pos.selected.queue_number,
  getPosSelectedTableNumber: state => state.pos.selected.table_number,
  getPosSelectedLots: state => state.pos.selected.lots,
  getPosSelectedSerials: state => state.pos.selected.serials,
  getPosTableById: (state) => (table_number) => {
    return state.pos.tables.find(table => table.table_number == table_number)
  },
  getPosQueueById: (state) => (queue_number) => {
    return state.pos.queues.find(queue => queue.queue_number == queue_number)
  },
  getPosSelectedCustomerId: state => state.pos.selected.customer_id,
  getPosSelectedDiningName: state => state.pos.selected.dining_name,
  getPosSelectedCustomerNew: state => state.pos.selected.customer_new,
  getPosTables: state => state.pos.tables,
  getPosEditOrder: state => state.pos.edit.order,
  trickCalculateTotalPrice: state => state.pos.trickCalculateTotalPrice,
  getPosStockBills: state => state.pos.stockBills,
  getPosStockBill: (state) => (uuid) => {
    return state.pos.stockBills.find(bill => bill.uuid === uuid)
  },
  getMoneyPaid: (state) => state.pos.receiptInfo.moneyPaidNumber,
  getMoneyChange: (state) => state.pos.receiptInfo.moneyChangeNumber,
  getReceiptInfo: (state) => state.pos.receiptInfo,
  getPosLocalStorage: (state) => (shop_id, session_id) => {
    let data = LocalStorage.get('pos') || []
    let result = data.find(obj => obj.shop_id == shop_id && obj.session_id == session_id)
    if (result) {
      return result.pos
    }
    return null
  },
  getPosAddedItemCount: state => state.pos.addedItemCount,
  getPosRemovedItemCount: state => state.pos.removedItemCount,
  isShowingConfirmClearPosOrdersModal: state => state.pos.isShowingConfirmClearPosOrdersModal,
  getPosQueues: state => state.pos.queues,
  getOrdersWithCondition: (state) => (use_queue, use_table) => {
    return state.pos.orders.filter((order) => {
      if (use_queue && order.queue_number != state.pos.selected.queue_number) {
        return false
      }
      if (use_table && order.table_number != state.pos.selected.table_number) {
        return false
      }
      return true
    })
  },
  getLatestQueueNumber: state => state.pos.latestQueueNumber,
  getUsedQueueNumbers: state => state.pos.usedQueueNumbers,
  getProductInfoById: state => (productId) => {
    const data = state.pos.products.find((item) => item.category_id === '2')
    const pdocuts = data.products
    return pdocuts.find((item) => item.product_id === productId)
  },
  getSkuInfoById: state => (skuId) => {
    const data = state.pos.products.find((item) => item.category_id === '2')
    const pdocuts = data.products
    return pdocuts.reduce((acc, cur) => {
      const sku = cur.prices.find((skuItem) => skuItem.sku_id === skuId)
      if (sku) {
        acc = sku
      }
      return acc
    }, null)
  },
  getNotifications: state => state.pos.notifications,
  isQueueNumberExist: state => (queueNumber) => {
    return state.pos.queues.some((queue) => queue.queue_number.toString() === queueNumber.toString())
  },
  unreadNotificationCount: state => {
    return state.pos.notifications.reduce((acc, cur) => {
      const notify = cur
      if (!notify.is_read) {
        acc += 1
      }
      return acc
    }, 0)
  },
  isSelectedCustomerByQueue: state => (queue_number) => {
    const findIndex = state.pos.queues.findIndex((queue) => queue.queue_number == queue_number)
    if (findIndex >= 0) {
      return !!state.pos.queues[findIndex].customer_id
    }
  },
}

// mutations
const mutations = {
  // set pos data
  setPos (state, pos) {
    state.pos = pos
  },
  // when we want go to other page, we use setPosSection
  setPosSection (state, section) {
    state.pos.prevSection = state.pos.section
    state.pos.section = section
  },
  // when we want go to other page with bidding data
  setPosSectionWith (state, obj) {
    let section = obj.section
    var data = obj.data

    switch (section) {
      case 'choose-attribute':
        if (data.product) {
          this.dispatch('setPosSelectedProduct', data.product)
        }
        if (data.sku_id) {
          this.dispatch('setPosSelectedSkuId', data.sku_id)
        }
        break
      case 'custom-price':
        if (data.product) {
          this.dispatch('setPosSelectedProduct', data.product)
        }
        if (data.sku_id) {
          this.dispatch('setPosSelectedSkuId', data.sku_id)
        }
        if (data.lots) {
          this.dispatch('setPosSelectedLots', data.lots)
        }
        if (data.serials) {
          this.dispatch('setPosSelectedSerials', data.serials)
        }
        break
    }

    // change section
    state.pos.prevSection = state.pos.section
    state.pos.section = section
  },
  setPosDisplay (state, data) {
    if (data.type) {
      state.pos.display.type = data.type
    }
    if (data.use_calculator) {
      state.pos.display.use_calculator = data.use_calculator
    }
    if (data.search !== undefined) {
      state.pos.display.search = data.search
    }
  },
  // after call api, we use setPosProducts
  setPosProducts (state, products) {
    state.pos.products = products
  },
  updatePosProductsStocks (state, stocks) {
    state.pos.products = state.pos.products.reduce((accItems, curItem) => {
      const products = curItem.products.reduce((accProducts, curProduct) => {
        const prices = curProduct.prices.reduce((accPrices, curPrice) => {
          const newStocks = curPrice.stocks.reduce((accStocks, curStock) => {
            const stock = stocks.find((stockItem) => stockItem.stock_id === curStock.stock_id)
            accStocks.push({
              ...curStock,
              instock: stock ? stock.instock : curStock.instock,
            })
            return accStocks
          }, [])
          const totalInstock = newStocks.reduce((acc, cur) => acc + cur.instock, 0)
          accPrices.push({
            ...curPrice,
            total_instock: totalInstock,
            stocks: newStocks,
          })
          return accPrices
        }, [])
        accProducts.push({
          ...curProduct,
          prices,
        })
        return accProducts
      }, [])
      accItems.push({
        ...curItem,
        products,
      })
      return accItems
    }, [])
  },
  // clear data
  clearPosProducts (state) {
    state.pos.products = []
  },
  // when we need to change category we use changePosCategory
  changePosCategory (state, category_id) {
    state.pos.selected.category_id = category_id
  },
  setPosQueues (state, queues) {
    state.pos.queues = queues
  },
  setPosTables (state, tables) {
    state.pos.tables = tables
  },
  // select queue
  setPosSelectedQueue (state, queue_number) {
    state.pos.selected.queue_number = queue_number
  },
  // select table
  setPosSelectedTable (state, table_number) {
    state.pos.selected.table_number = table_number

    const useQueue = this.getters.getPosSetting.queue.is_active
    if (useQueue) {
      const queueIndex = state.pos.queues.findIndex((queueItem) => (
        queueItem.queue_number == state.pos.selected.queue_number
      ))
      if (queueIndex >= 0) {
        state.pos.queues[queueIndex]['table_number'] = state.pos.selected.table_number
      }
    }

    this.dispatch('clearEmptyTables')

    /**
     * มีลูกค้าด่ามา เพราะระบบเลือก table เอง โดยที่ user ไม่รู้ ทำให้คิดเงินผิด
     */
    // move order from unseleced table to this one
    // if (table_number != null) {
    //   state.pos.orders.forEach((order, index) => {
    //     if (order.table_number == null) {
    //       const foundTable = state.pos.tables.find((table) => table.table_number == table_number)
    //       if (!foundTable) {
    //         this.dispatch('addPosTable', table_number)
    //       }
    //       state.pos.orders[index].table_number = table_number
    //     }
    //   })
    // }
  },
  clearEmptyTables(state) {
    state.pos.tables = state.pos.tables.filter((table) => {
      const orders = state.pos.orders.filter((order) => order.table_number == table.table_number)
      return orders.length > 0 || table.customer_id != null
    })
  },
  addPosQueue (state, options) {
    const queue_number = options.queue_number
    const table_number = options.table_number
    const customer_id = options.customer_id
    const dining_name = options.dining_name
    const qrcode_id = options.qrcode_id
    const qrcode_type = options.qrcode_type
    const expired_at = options.expired_at
    const expire_time_mins = options.expire_time_mins

    const found = state.pos.queues.find((queueItem) => queueItem.queue_number == queue_number)
    if (!found) {
      state.pos.queues.push({
        queue_number: queue_number,
        start_at: Date.now(),
        table_number: table_number || null,
        customer_id: customer_id || null,
        dining_name: dining_name || null,
        qrcode_id: qrcode_id || null,
        qrcode_type: qrcode_type || null,
        expired_at: expired_at || null,
        expire_time_mins: expire_time_mins || null,
      })
    }
  },
  addPosTable (state, table_number) {
    let found = state.pos.tables.find(table => table.table_number == table_number)
    if (!found && table_number !== null) {
      state.pos.tables.push({
        table_number: table_number,
        start_at: Date.now(),
        customer_id: state.pos.selected.customer_id,
        dining_name: state.pos.selected.dining_name,
      })
    }
  },
  updatePosQueueCustomerId(state, { queue_number, customer_id }) {
    const findIndex = state.pos.queues.findIndex((queue) => queue.queue_number == queue_number)
    if (findIndex >= 0) {
      state.pos.queues[findIndex].customer_id = customer_id
      if (state.pos.selected.queue_number == queue_number) {
        state.pos.selected.customer_id = customer_id
      }
    }
  },
  deletePosQueue (state, queue_number) {
    for (let i in this.state.pos.pos.queues) {
      let item = this.state.pos.pos.queues[i]
      if (item.queue_number == queue_number) {
        this.state.pos.pos.queues.splice(i, 1)
      }
    }
    if (queue_number == this.state.pos.pos.selected.queue_number) {
      if (this.state.pos.pos.queues.length) {
        this.dispatch('setPosSelectedQueue', this.state.pos.pos.queues[0].queue_number)
      }
    }
  },
  deletePosTable (state, table_number) {
    for (let i in this.state.pos.pos.tables) {
      let item = this.state.pos.pos.tables[i]
      if (item.table_number == table_number) {
        this.state.pos.pos.tables.splice(i, 1)
      }
    }
  },
  // when clicked the product
  setPosSelectedProduct (state, data) {
    state.pos.selected.product = data
  },
  // custom price
  setPosSelectedSkuId (state, data) {
    state.pos.selected.sku_id = data
  },
  clearPosSelectedTable (state) {
    state.pos.selected.table_number = null
  },
  clearPosSelectedCustomerId (state, { queue_number, table_number }) {
    state.pos.selected.customer_id = null
    state.pos.selected.customer_new = null

    if (queue_number) {
      if (state.pos.queues.length) {
        for (let i = 0; i < state.pos.queues.length; i++) {
          if (state.pos.queues[i].queue_number == queue_number) {
            state.pos.queues[i].customer_id = null
          }
        }
      }
    }

    if (table_number) {
      if (state.pos.tables.length) {
        for (let i = 0; i < state.pos.tables.length; i++) {
          if (state.pos.tables[i].table_number == table_number) {
            state.pos.tables[i].customer_id = null
          }
        }
      }
    }
  },
  clearPosSelectedDiningName (state, { queue_number, table_number }) {
    state.pos.selected.dining_name = null

    if (queue_number) {
      if (state.pos.queues.length) {
        for (let i = 0; i < state.pos.queues.length; i++) {
          if (state.pos.queues[i].queue_number == queue_number) {
            state.pos.queues[i].dining_name = null
          }
        }
      }
    }

    if (table_number) {
      if (state.pos.tables.length) {
        for (let i = 0; i < state.pos.tables.length; i++) {
          if (state.pos.tables[i].table_number == table_number) {
            state.pos.tables[i].dining_name = null
          }
        }
      }
    }
  },
  setPosSelectedCustomerId (state, { customer_id, customer_new }) {
    state.pos.selected.customer_id = customer_id
    state.pos.selected.customer_new = customer_new
  },
  setPosSelectedDiningName (state, { name }) {
    state.pos.selected.dining_name = name
  },
  setCustomIdForQueueAndTable () {
    const setQueueCustomerId = () => {
      const queueIndex = state.pos.queues.findIndex((queueItem) => (
        queueItem.queue_number == state.pos.selected.queue_number
      ))
      if (queueIndex >= 0) {
        state.pos.queues[queueIndex]['customer_id'] = state.pos.selected.customer_id
        return true
      }
      return false
    }

    const setTableCustomerId = () => {
      const tableIndex = state.pos.tables.findIndex((tableItem) => (
        tableItem.table_number == state.pos.selected.table_number
      ))
      if (tableIndex >= 0) {
        state.pos.tables[tableIndex]['customer_id'] = state.pos.selected.customer_id
        return true
      }
      return false
    }

    setQueueCustomerId()

    if (!setTableCustomerId()) {
      this.dispatch('addPosTable', state.pos.selected.table_number)
      setTableCustomerId()
    }
  },
  setDiningNameForQueueAndTable (state) {
    const setQueueDiningName = () => {
      const queueIndex = state.pos.queues.findIndex((queueItem) => (
        queueItem.queue_number == state.pos.selected.queue_number
      ))
      if (queueIndex >= 0) {
        state.pos.queues[queueIndex]['dining_name'] = state.pos.selected.dining_name
        return true
      }
      return false
    }

    const setTableDiningName = () => {
      const tableIndex = state.pos.tables.findIndex((tableItem) => (
        tableItem.table_number == state.pos.selected.table_number
      ))
      if (tableIndex >= 0) {
        state.pos.tables[tableIndex]['dining_name'] = state.pos.selected.dining_name
        return true
      }
      return false
    }

    setQueueDiningName()

    if (!setTableDiningName()) {
      this.dispatch('addPosTable', state.pos.selected.table_number)
      setTableDiningName()
    }
  },
  setPosSelectedLots (state, lots) {
    state.pos.selected.lots = lots
  },
  setPosSelectedSerials (state, serials) {
    state.pos.selected.serials = serials
  },
  // add order
  addPosOrder (state, newOrder) {
    // compare new order with old one
    let oldOrder = getOrderWithCompare(newOrder, state.pos.orders)
    let isSameThing = !!oldOrder

    if (isSameThing) {
      oldOrder.quantity += newOrder.quantity
    } else {
      newOrder.uuid = uuid.v1()
      state.pos.orders.push(newOrder)
    }
  },
  setPosOrders (state, orders) {
    state.pos.orders = orders
  },
  // update order
  updatePosOrder (state, newOrder) {
    let orders = state.pos.orders
    for (let i in orders) {
      let item = orders[i]
      if (item.uuid == newOrder.uuid) {
        orders[i] = newOrder
      }
    }
  },
  updatePosOrderDiscounts (state, { orderId, discounts }) {
    const orders = state.pos.orders
    const newOrders = []
    for (const i in orders) {
      const order = orders[i]
      if (order.uuid == orderId) {
        newOrders.push({
          ...order,
          discounts,
        })
      } else {
        newOrders.push(order)
      }
    }
    state.pos.orders = [...newOrders]
  },
  // delete order by item
  deletePosOrder (state, uuid) {
    for (let i in this.state.pos.pos.orders) {
      let item = this.state.pos.pos.orders[i]
      if (item.uuid == uuid) {
        this.state.pos.pos.orders.splice(i, 1)
      }
    }
    let table_number = this.getters.getPosSelectedTableNumber
    let queue_number = this.getters.getPosSelectedQueueNumber
    let orders = this.getters.getPosOrdersById({
      queue_number,
      table_number,
    })
    if (orders.length == 0) {
      this.dispatch('deletePosTable', table_number)
    }
    state.pos.removedItemCount++
  },
  showingConfirmClearPosOrdesrModal(state, bool) {
    state.pos.isShowingConfirmClearPosOrdersModal = bool
  },
  clearPosOrderBy (state, { queue_number, table_number, isDeleteQueue = false }) {
    var orders = this.state.pos.pos.orders
    var removeAtIdx = []
    for (let i in orders) {
      let item = orders[i]
      if (item.queue_number == queue_number && item.table_number == table_number) {
        removeAtIdx.push(i)
      }
    }
    removeAtIdx.reverse().forEach(function (index) {
      orders.splice(index, 1)
    })
    if (isDeleteQueue) {
      this.dispatch('deletePosQueue', queue_number)
    }
    this.dispatch('deletePosTable', table_number)
  },
  // clear order all
  clearPosOrderAll (state, table_number) {
    this.state.pos.pos.orders = []
  },
  // set data edit
  setPosEditOrder (state, data) {
    return state.pos.edit.order = data
  },
  // trick calculate total price
  doCalculateTotalPrice (state) {
    return state.pos.trickCalculateTotalPrice++
  },
  // add bill to stock
  addPosStockBill (state, bill) {
    bill.uuid = uuid.v1()
    state.pos.stockBills.push(bill)
  },
  setPosStockBills (state, bills) {
    state.pos.stockBills = bills
  },
  deletePosStockBill (state, uuid) {
    for (let i in this.state.pos.pos.stockBills) {
      let item = this.state.pos.pos.stockBills[i]
      if (item.uuid == uuid) {
        this.state.pos.pos.stockBills.splice(i, 1)
      }
    }
  },
  setPosLocalStorage (state, data) {
    let old = LocalStorage.get('pos')
    var result = null

    if (old == undefined) {
      result = [{
        'shop_id': data.shop_id,
        'session_id': data.session_id,
        'pos': state.pos,
      }]
    } else if (typeof old === 'object') {
      let getObj = old.find((obj) => {
        return obj.shop_id == data.shop_id && obj.session_id == data.session_id
      })

      if (!getObj) {
        old.push({
          'shop_id': data.shop_id,
          'session_id': data.session_id,
          'pos': state.pos,
        })
      } else {
        getObj.pos = state.pos
      }

      var newArray = []
      var maxLength = 5

      if (old.length <= maxLength) {
        var startAt = old.length - maxLength
        for (let i in old) {
          if (i >= startAt) {
            newArray.push(old[i])
          }
        }
      }

      result = newArray
    }

    // storage data
    if (result !== null) {
      LocalStorage.set('pos', result)
    }
  },
  setMoneyPaid (state, number) {
    state.pos.receiptInfo.moneyPaidNumber = number
  },
  setMoneyChange (state, number) {
    state.pos.receiptInfo.moneyChangeNumber = number
  },
  setReceiptInfo (state, data) {
    state.pos.receiptInfo = data
  },
  setLastSecIsBarcode (state, bool) {
    state.pos.lastSecIsBarcode = bool
  },
  addedItemCount (state) {
    state.pos.addedItemCount++
  },
  removedItemCount (state) {
    state.pos.removedItemCount++
  },
  autoSelectCustomerAndDinning(state) {
    const useQueue = this.getters.getPosSetting.queue.is_active
    const useTable = this.getters.getPosSetting.table.is_active

    /**
     * clear selected state
     */
    if ((useTable && state.pos.selected.table_number) != null && (useQueue && state.pos.selected.queue_number != null)) {
      state.pos.selected.table_number = null
    }
    if (state.pos.selected.customer_id != null) {
      state.pos.selected.customer_id = null
    }
    if (state.pos.selected.dining_name != null) {
      state.pos.selected.dining_name = null
    }

    /**
     * set selected state
     */
    if (useQueue && state.pos.selected.queue_number != null) {
      const queue = state.pos.queues.find((item) => (
        item.queue_number == state.pos.selected.queue_number
      ))
      if (queue && queue.table_number) {
        state.pos.selected.table_number = queue.table_number
      }
      if (queue && queue.customer_id) {
        state.pos.selected.customer_id = queue.customer_id
      }
      if (queue && queue.dining_name) {
        state.pos.selected.dining_name = queue.dining_name
      }
    }
    else if (useTable && state.pos.selected.table_number != null) {
      const table = state.pos.tables.find((item) => (
        item.table_number == state.pos.selected.table_number
      ))
      if (table && table.customer_id) {
        state.pos.selected.customer_id = table.customer_id
      }
      if (table && table.dining_name) {
        state.pos.selected.dining_name = table.dining_name
      }
    }
  },
  setPosLatestQueueNumber(state, latestQueueNumber) {
    state.pos.latestQueueNumber = latestQueueNumber
  },
  setPosNextQueueNumber(state, currentQueueNumber) {
    let max = Math.max(currentQueueNumber, ...state.pos.usedQueueNumbers)
    for (let i = 0; i < state.pos.queues.length; i++) {
      if (state.pos.queues[i].queue_number > max) {
        max = state.pos.queues[i].queue_number
      }
    }

    if (max >= state.pos.latestQueueNumber) {
      state.pos.latestQueueNumber = max
    }
  },
  setPosUsedQueueNumbers(state, usedQueueNumbers) {
    state.pos.usedQueueNumbers = usedQueueNumbers
  },
  clearPosMasterData(state) {
    state.pos.queues = []
    state.pos.tables = []
    state.pos.orders = []

    state.pos.selected.queue_number = null
    state.pos.selected.table_number = null
    state.pos.selected.dining_name = null
    state.pos.selected.customer_id = null

    state.pos.prevSection = null
  },
  addPosNextQueue(state) {
    const defaultDining = this.getters.getPosSetting.dining.options.find((item) => item.is_default).name
    const qNumber = (() => {
      if (state.pos.queues.length === 0) {
        return state.pos.latestQueueNumber + 1
      } else {
        let max = Math.max(0, ...state.pos.usedQueueNumbers)
        for (let i = 0; i < state.pos.queues.length; i++) {
          if (state.pos.queues[i].queue_number > max) {
            max = state.pos.queues[i].queue_number
          }
        }
        return max + 1
      }
    })()

    this.dispatch('addPosQueue', qNumber)
    this.dispatch('setPosSelectedQueue', qNumber)

    const useDining = this.getters.getPosSetting.dining.is_active
    if (useDining) {
      this.dispatch('setPosSelectedDiningName', {
        name: defaultDining,
      })
      this.dispatch('setDiningNameForQueueAndTable')
    }
  },
  setNotifications(state, notifications) {
    state.pos.notifications = []

    const sortResults = notifications.sort((a, b) => b.created_at - a.created_at)
    state.pos.notifications = sortResults
  },
  movePosOrderToTable(state, { fromTable, toTable, queueNumber }) {
    // move orders, dining, customer to new table
    if (queueNumber != null) {
      state.pos.orders.forEach((order, index) => {
        if (order.table_number == fromTable && state.pos.orders[index].queue_number == queueNumber) {
          state.pos.orders[index].table_number = toTable
        }
      })
    } else {
      state.pos.orders.forEach((order, index) => {
        if (order.table_number == fromTable) {
          state.pos.orders[index].table_number = toTable
        }
      })
    }

    // clear old table data
    state.pos.tables = state.pos.tables.filter((table) => table.table_number != fromTable)

    if (queueNumber != null) {
      state.pos.queues.forEach((queue, index) => {
        if (queue.queue_number == queueNumber) {
          state.pos.queues[index].table_number = toTable
        }
      })
    }
  },
}

// actions
const actions = {
  setPos ({ commit }) {
    commit('setPos')
  },
  setPosSection ({ commit }, section) {
    commit('setPosSection', section)
  },
  setPosSectionWith ({ commit }, data) {
    commit('setPosSectionWith', data)
  },
  setPosDisplay ({ commit }, data) {
    commit('setPosDisplay', data)
  },
  async getPosProducts ({ commit }, params = {}) {
    var result

    // check this api is still loading or not
    if (this.state.app.loadinglist.indexOf('getPosProducts') >= 0) return

    try {
      // start loading
      this.dispatch('Loading', true)
      // clear error
      this.dispatch('Error', null)
      // add loadinglist
      this.dispatch('addLoadinglist', 'getPosProducts')

      let response = await ProductService.getPosProducts(params)

      // stop loading
      this.dispatch('Loading', false)
      // remove loadinglist
      this.dispatch('removeLoadinglist', 'getPosProducts')

      result = response.data

      if (result.success) {
        commit('setPosProducts', result.data)
      } else {
        this.dispatch('Error', typeof result.error === 'string' ? result.error : result.status_message)
      }
    } catch (e) {
      this.dispatch('Error', e)
    }
    return result
  },
  clearPosProducts ({ commit }) {
    commit('clearPosProducts')
  },
  changePosCategory ({ commit }, category_id) {
    commit('changePosCategory', category_id)
  },
  setPosQueues ({ commit }, queues) {
    commit('setPosQueues', queues)
  },
  setPosTables ({ commit }, tables) {
    commit('setPosTables', tables)
  },
  setPosSelectedQueue ({ commit }, queue_number) {
    commit('setPosSelectedQueue', queue_number)
    commit('autoSelectCustomerAndDinning')
  },
  setPosSelectedTable ({ commit }, table_number) {
    commit('setPosSelectedTable', table_number)
    commit('autoSelectCustomerAndDinning')
  },
  setPosSelectedProduct ({ commit }, data) {
    commit('setPosSelectedProduct', data)
  },
  clearPosSelectedProduct ({ commit }) {
    commit('setPosSelectedProduct', null)
  },
  setPosSelectedSkuId ({ commit }, data) {
    commit('setPosSelectedSkuId', data)
  },
  clearPosSelectedSkuId ({ commit }) {
    commit('setPosSelectedSkuId', null)
  },
  clearPosSelectedLots ({ commit }) {
    commit('setPosSelectedLots', [])
  },
  clearPosSelectedSerials ({ commit }) {
    commit('setPosSelectedSerials', [])
  },
  setPosSelectedCustomerId ({ commit }, { customer_id, customer_new }) {
    commit('setPosSelectedCustomerId', {
      customer_id,
      customer_new,
    })
  },
  setPosSelectedDiningName ({ commit }, { name }) {
    commit('setPosSelectedDiningName', { name })
  },
  setPosSelectedLots ({ commit }, data) {
    commit('setPosSelectedLots', data)
  },
  setPosSelectedSerials ({ commit }, data) {
    commit('setPosSelectedSerials', data)
  },
  addPosOrder ({ commit, state }, order) {
    const newOrder = order
    let oldOrder = getOrderWithCompare(newOrder, state.pos.orders)
    let isSameThing = !!oldOrder

    if (!isSameThing) {
      if (order.delay === undefined) {
        commit('addedItemCount')
      } else {
        setTimeout(() => {
          commit('addedItemCount')
        }, order.delay)
      }
    }

    commit('addPosOrder', order)
    commit('addPosTable', order.table_number)
    commit('doCalculateTotalPrice')
  },
  setPosOrders ({ commit }, orders) {
    commit('setPosOrders', orders)
  },
  updatePosOrder ({ commit }, order) {
    commit('updatePosOrder', order)
    // I added delay because fucking bug that I don't know
    setTimeout(() => {
      commit('doCalculateTotalPrice')
    }, 1)
  },
  updatePosOrderDiscounts ({ commit }, { orderId, discounts }) {
    commit('updatePosOrderDiscounts', { orderId, discounts })
    // I added delay because fucking bug that I don't know
    setTimeout(() => {
      commit('doCalculateTotalPrice')
    }, 1)
  },
  deletePosOrder ({ commit }, uuid) {
    commit('deletePosOrder', uuid)
    commit('doCalculateTotalPrice')
    commit('autoSelectCustomerAndDinning')
  },
  deletePosQueue ({ commit }, queue_number) {
    commit('deletePosQueue', queue_number)
  },
  deletePosTable ({ commit }, table_number) {
    commit('deletePosTable', table_number)
  },
  setPosEditOrder ({ commit }, order) {
    commit('setPosEditOrder', order)
  },
  clearPosEditOrder ({ commit }) {
    commit('setPosEditOrder', null)
  },
  doCalculateTotalPrice ({ commit }) {
    commit('doCalculateTotalPrice')
  },
  showingConfirmClearPosOrdesrModal ({ commit }, bool) {
    commit('showingConfirmClearPosOrdesrModal', bool)
  },
  clearPosOrderBy ({ commit }, table_number) {
    commit('clearPosOrderBy', table_number)
  },
  clearPosOrderAll ({ commit }) {
    commit('clearPosOrderAll')
  },
  addPosStockBill ({ commit }, bill) {
    commit('addPosStockBill', bill)
  },
  setPosStockBills ({ commit }, bills) {
    commit('setPosStockBills', bills)
  },
  deletePosStockBill ({ commit }, uuid) {
    commit('deletePosStockBill', uuid)
  },
  setPosLocalStorage ({ commit }, { psId }) {
    let shopInfo = this.getters.getShopInfo
    let shop_id = shopInfo.shop_id
    let session_id = psId

    commit('setPosLocalStorage', {
      shop_id: shop_id,
      session_id: session_id,
    })
  },
  setMoneyPaid ({ commit }, number) {
    commit('setMoneyPaid', number)
  },
  setMoneyChange ({ commit }, number) {
    commit('setMoneyChange', number)
  },
  setReceiptInfo ({ commit }, data) {
    commit('setReceiptInfo', data)
  },
  setLastSecIsBarcode ({ commit }, bool) {
    commit('setLastSecIsBarcode', bool)
  },
  initPos ({ commit }, data) {
    // clear state first
    commit('clearPosMasterData')

    /**
     * state state from local storeage
     */
    let stockbills = data.stockbills || []
    let orders = data.orders || []
    let tables = data.tables || []
    let display = data.display
    let queues = data.queues || []

    if (stockbills.length > 0) commit('setPosStockBills', stockbills)
    if (display) commit('setPosDisplay', display)
    if (queues) commit('setPosQueues', queues)
    if (tables.length > 0) commit('setPosTables', tables)
    if (orders.length > 0) commit('setPosOrders', orders)

    const useQueue = this.getters.getPosSetting.queue.is_active
    const useTable = this.getters.getPosSetting.table.is_active
    if (queues.length && useQueue) {
      commit('setPosSelectedQueue', queues[0].queue_number)
      commit('autoSelectCustomerAndDinning')
    }
    else if (tables.length && useTable) {
      commit('setPosSelectedTable', tables[0].table_number)
      commit('autoSelectCustomerAndDinning')
    }
  },
  posAddedItemCount ({ commit }) {
    commit('addedItemCount')
  },
  posRemovedItemCount ({ commit }) {
    commit('removedItemCount')
  },
  addPosQueue({ commit }, queue_number) {
    commit('addPosQueue', { queue_number })

    // add queue number to firebase too
    const isActive_menuOnline = this.getters.getPosSetting.menu_online.is_active
    if (isActive_menuOnline) {
      const shopId = this.getters.getAuth.shop_info.shop_id
      const branchId = this.getters.getPosSession.branch_id
      const psId = this.getters.getPosSession.ps_id
      const tableNumber = null
      FirebaseService.createQueue(shopId, branchId, psId, queue_number, tableNumber)
    }
  },
  addPosQueueWith({ commit }, options) {
    commit('addPosQueue', {
      ...options,
    })
  },
  addPosTable({ commit }, table_number) {
    commit('addPosTable', table_number)
  },
  updatePosQueueCustomerId({ commit }, { queue_number, customer_id }) {
    commit('updatePosQueueCustomerId', { queue_number, customer_id })
  },
  setCustomIdForQueueAndTable({ commit }) {
    commit('setCustomIdForQueueAndTable')
  },
  setDiningNameForQueueAndTable({ commit }) {
    commit('setDiningNameForQueueAndTable')
  },
  clearPosSelectedTable({ commit }) {
    commit('clearPosSelectedTable')
    commit('clearEmptyTables')
  },
  clearPosSelectedCustomerId({ commit }, { queue_number, table_number }) {
    commit('clearPosSelectedCustomerId', { queue_number, table_number })
  },
  clearPosSelectedDiningName({ commit }, { queue_number, table_number }) {
    commit('clearPosSelectedDiningName', { queue_number, table_number })
  },
  setPosLatestQueueNumber({ commit }, latestQueueNumber) {
    commit('setPosLatestQueueNumber', latestQueueNumber)
  },
  setPosNextQueueNumber({ commit }, currentQueueNumber) {
    commit('setPosNextQueueNumber', currentQueueNumber)
  },
  setPosUsedQueueNumbers({ commit }, usedQueueNumbers) {
    commit('setPosUsedQueueNumbers', usedQueueNumbers)
  },
  clearPosMasterData({ commit }) {
    commit('clearPosMasterData')
  },
  addPosNextQueue({ commit }) {
    commit('addPosNextQueue')
  },
  setNotifications({ commit }, notifications) {
    commit('setNotifications', notifications)
  },
  updateNotify({ commit }, { queueNumber, notifyId, payload }) {
    const shopId = this.getters.getAuth.shop_info.shop_id
    const branchId = this.getters.getPosSession.branch_id
    const psId = this.getters.getPosSession.ps_id
    FirebaseService.updateNotify(shopId, branchId, psId, queueNumber, notifyId, payload)
  },
  updateNotifies({ commit }, { notifies, payload }) {
    const shopId = this.getters.getAuth.shop_info.shop_id
    const branchId = this.getters.getPosSession.branch_id
    const psId = this.getters.getPosSession.ps_id
    FirebaseService.updateNotifies(shopId, branchId, psId, notifies, payload)
  },
  updateClient({ commit }, { clientId, payload }) {
    const shopId = this.getters.getAuth.shop_info.shop_id
    const branchId = this.getters.getPosSession.branch_id
    const psId = this.getters.getPosSession.ps_id
    FirebaseService.updateClient(shopId, branchId, psId, clientId, payload)
  },
  createOrder({ commit }, { queueNumber, orderId, payload }) {
    const shopId = this.getters.getAuth.shop_info.shop_id
    const branchId = this.getters.getPosSession.branch_id
    const psId = this.getters.getPosSession.ps_id
    FirebaseService.createOrder(shopId, branchId, psId, queueNumber, orderId, payload)
  },
  updateOrder({ commit }, { queueNumber, orderId, payload }) {
    const shopId = this.getters.getAuth.shop_info.shop_id
    const branchId = this.getters.getPosSession.branch_id
    const psId = this.getters.getPosSession.ps_id
    FirebaseService.updateOrder(shopId, branchId, psId, queueNumber, orderId, payload)
  },
  updatePosProductsStocks({ commit }, stocks) {
    commit('updatePosProductsStocks', stocks)
  },
  movePosOrderToTable({ commit }, { fromTable, toTable, queueNumber }) {
    commit('movePosOrderToTable', {
      fromTable,
      toTable,
      queueNumber,
    })
  },
  clearEmptyTables({ commit }) {
    commit('clearEmptyTables')
  },
}

export default {
  state,
  getters,
  mutations,
  actions,
}



// WEBPACK FOOTER //
// ./src/store/modules/Pos.js